<div
    class="flex flex-col justify-between items-center rounded-tr-lg rounded-br-lg absolute session-skin p-1 relative overflow-hidden">
    <div class="h-full min-w-1 bg-primary absolute top-0 left-0"></div>

    <fm-session-indicator-icons
        [isQuietMode]="sessionInfo.quietMode"
        [activityType]="sessionInfo.activityType"
        [showActivityType]="true"
        [isLockedIn]="false"
        [sessionDuration]="sessionInfo.sessionDuration"
        class="absolute right-2 top-0" />

    <div class="flex justify-start items-start w-full ml-1 max-w-full pr-2">
        <div
            class="h-full flex flex-col justify-between items-start ml-1 mt-0.5 max-w-full flex-grow w-[calc(100%_-_50px)]">
            <div class="text-12-16 leadning-normal text-color font-medium text-left font-inter"
                >{{
                    sessionInfo.sessionTime
                        | epochToTime: { format: 'dddd, MMMM D', timezone: user.timeZone }
                }}
            </div>
            <div class="text-12-16 leadning-normal text-color font-medium text-left font-inter">
                {{
                    sessionInfo.sessionTime
                        | epochToTime
                            : {
                                  format: displayTimeFormat,
                                  timezone: user.timeZone,
                              }
                }}

                -
                {{
                    sessionInfo.sessionTime + sessionInfo.sessionDuration
                        | epochToTime
                            : {
                                  format: displayTimeFormat,
                                  timezone: user.timeZone,
                              }
                }}
            </div>
            <div
                class="text-12-16 leadning-normal text-color font-medium text-left font-inter truncate whitespace-nowrap overflow-hidden text-ellipsis max-w-full"
                >{{ partnerNameOrStatusString }}</div
            >
        </div>
    </div>
    <div class="flex flex-row justify-end items-center w-full gap-1">
        <p-button
            [buttonProps]="{ autofocus: false }"
            severity="secondary"
            class="fm-button-xsmall"
            size="small"
            (click)="onClickRemoveSession()"
            icon="pi pi-times" />
    </div>
</div>
